/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_MediaInputs */



/**
* | output |
* | --- |
* | "OCR Media" |
*
* @param {Ocr_MediaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_media = /** @type {((inputs?: Ocr_MediaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_MediaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Médias OCR")
	if (locale === "de") return /** @type {LocalizedString} */ ("OCR-Medien")
	if (locale === "it") return /** @type {LocalizedString} */ ("OCR Media")
	if (locale === "ru") return /** @type {LocalizedString} */ ("OCR Media")
	if (locale === "es") return /** @type {LocalizedString} */ ("Medios OCR")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("OCR 媒体")
	if (locale === "ja") return /** @type {LocalizedString} */ ("OCRメディア")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ओसीआर मीडिया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mídia OCR")
	return /** @type {LocalizedString} */ ("OCR Media")
});